/**
 * Messages d'erreur et de succès centralisés
 */



export const AUTH_MESSAGES = {
  // Messages d'erreur générique
  AUTHENTICATION_ERROR: 'Erreur lors de l\'authentification',
  
  // Messages pour le formulaire
  ACCOUNT_CREATION_TITLE: 'Créer un compte',
  LOGIN_TITLE: 'Se connecter',
  ACCOUNT_CREATION_SUBTITLE: 'Rejoignez notre plateforme Time Tracker',
  LOGIN_SUBTITLE: 'Accédez à votre espace',
  
  // Messages d'action
  CREATE_ACCOUNT_BUTTON: 'Créer mon compte',
  LOGIN_BUTTON: 'Se connecter',
  LOADING: 'Chargement...',
  
  // Messages de navigation
  ALREADY_HAVE_ACCOUNT: 'Déjà un compte ? Se connecter',
  NO_ACCOUNT_YET: 'Pas encore de compte ? S\'inscrire',
  
  // Messages informatifs
  FREE_ACCOUNT_TITLE: 'Compte gratuit',
  FREE_ACCOUNT_DESCRIPTION: 'Créez votre compte gratuitement. Vous pourrez configurer votre abonnement Time Tracker Pro depuis votre profil après inscription.'
};

export const FORM_MESSAGES = {
  // Placeholders
  PLACEHOLDER_FIRSTNAME: 'Prénom',
  PLACEHOLDER_LASTNAME: 'Nom',
  PLACEHOLDER_EMAIL: 'Adresse email',
  PLACEHOLDER_PASSWORD: 'Mot de passe',
  
  // Labels pour l'accessibilité
  LABEL_FIRSTNAME: 'Prénom',
  LABEL_LASTNAME: 'Nom',
  LABEL_EMAIL: 'Adresse email',
  LABEL_PASSWORD: 'Mot de passe'
};
